import { prefixObjectValues } from "../../../utils";

const modal = {
  title: 'title',
  deaNum: 'deaNum',
  licenseNotes: 'licenseNotes',
  issueDate: 'issueDate',
  expiryDate: 'expiryDate',
  activeFlag: 'activeFlag',
  restrictedUseFlag: 'restrictedFlag',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
}

export default prefixObjectValues(modal, 'account-licenses-dea-modal');




